import ActivityIcon from './ActivityIcon'

export default ActivityIcon
